import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import { LoadingPage } from 'Components/';
import { CEP_SETUP_FORM_NAME } from 'Common/FormEnum';
import { Filter, Main } from 'Containers/';
import {
  getSitesByFiscalYear,
  getFiscalYears,
  setSiteDataByFiscalYear,
} from './state/setup/actions';
import { FiscalYearForm } from './components/FiscalYearForm';
import { CEPSetupFieldEnum as Fields } from 'Common/FieldEnum';
import { FiscalYearSelector } from './components/FiscalYearSelector';
import { toastError } from 'Common/ToastHelper';
import { createToast, toastType } from 'Common/ToastHelper';

export class CEPSetupContainer extends Component {
  componentDidMount = () => {
    this.props.getFiscalYears();
  };

  state = {
    fiscalYear: '',
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: CEP_SETUP_FORM_NAME,
        saveButtonProps: {
          content: 'Submit',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  getInitialYear = () => {
    return this.props.fiscalYears[0] ? this.props.fiscalYears[0].value : null;
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { getSitesByFiscalYear, fiscalYears } = this.props;
    const { fiscalYear } = this.state;

    if (prevProps.fiscalYears !== fiscalYears) {
      this.setState({ fiscalYear: this.getInitialYear() });
    }
    if (prevState.fiscalYear !== fiscalYear) {
      getSitesByFiscalYear(fiscalYear);
    }
  };

  handleSubmit = values => {
    let errors = [];

    for (let site of values.Sites) {
      if (Number.isNaN(Number.parseFloat(site.Percentage))) {
        errors.push('Identified Students % values cannot be blank.');
        break;
      }
    }

    for (let site of values.Sites) {
      if (Number.parseFloat(site.Percentage) > 100) {
        errors.push('Identified Students % values must be 100 or lower.');
        break;
      }
    }

    if (errors.length > 0) {
      errors.forEach(error => {
        toastError(error);
      });
    } else {
      this.props.setSiteDataByFiscalYear(values);
      createToast(toastType.success, 'Success', 'Changes successfully saved.');
    }
  };

  render() {
    const {
      formValues,
      fiscalYears,
      loading,
      sites,
      sitesLoading,
    } = this.props;

    return (
      <Fragment>
        {loading && <LoadingPage />}
        <Filter title={'CEP Setup'} />
        <Main {...this.getMainProps()}>
          <FiscalYearSelector
            fiscalYears={fiscalYears}
            loading={loading}
            onChange={(e, v) => this.setState({ fiscalYear: v.value })}
            value={this.state.fiscalYear}
          />
          <FiscalYearForm
            initialValues={{
              [Fields.Sites]: sites,
            }}
            fiscalYears={fiscalYears}
            formValues={formValues ? formValues : {}}
            loading={loading}
            sitesLoading={sitesLoading}
            onSubmit={this.handleSubmit}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { CEPSetup } = state.CEPSetupState;
  return {
    formValues: getFormValues(CEP_SETUP_FORM_NAME)(state),
    loading: CEPSetup.loading,
    sites: CEPSetup.sites,
    fiscalYears: CEPSetup.fiscalYears,
    sitesLoading: CEPSetup.sitesLoading,
    fiscalYear: CEPSetup.fiscalYear,
  };
};

export const CEPSetup = withRouter(
  connect(
    mapStateToProps,
    {
      getSitesByFiscalYear,
      getFiscalYears,
      setSiteDataByFiscalYear,
    }
  )(CEPSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/cepsetup/CEPSetup.js